export * from './user.service';



// WEBPACK FOOTER //
// ./src/_services/index.js